<template>
  <div class="list">
    <div class="list-wrap">
      <div class="breadcrumb">
        <div class="breadcrumb-now">当前位置</div>
        <div class="breadcrumb-item" @click="toHome">首页</div>
        <div class="breadcrumb-icon">></div>
        <div class="breadcrumb-item">列表</div>
      </div>
      <div class="list-content" v-loading="loading">
        <div class="list-l">
          <p class='tit'>教育资讯</p>
          <div
            class="list-l-item"
            :class="{ active: activeTab.columnId == item.columnId }"
            v-for="(item, index) in tabList.imageColumnList"
            @click="tabChange(item)"
            :key="item.columnId"
          >
            {{ item.columnName }}
          </div>
          <p class='tit'>最新动态</p>
          <div
            class="list-l-item"
            :class="{ active: activeTab.columnId == item.columnId }"
            v-for="(item, index) in tabList.columnList"
            @click="tabChange(item)"
            :key="item.columnId"
          >
            {{ item.columnName }}
          </div>
        </div>
        <div class="list-r">
          <div class="list-r-title">{{ activeTab.columnName }}</div>
          <div class="list-r-list">
            <template v-if="newsList.length > 0">
              <div
                class="list-r-item"
                v-for="(item, index) in newsList"
                :key="index"
                @click="toDetail(item)" >
                 <template v-if='activeTab.typeCode=="IMAGE_TEXT"'>
                   <div class="img">
                      <img :src="item.innerImage" />
                   </div>
                 </template>
                 <template v-else>
                   <div class="img">
                      <p>{{item.time[1]}}<br><span>{{item.time[0]}}</span></p>
                   </div>
                 </template>
                <div class="info">
                  <div class="title" :title="item.title">{{ item.title }}</div>
                  <div class="des">{{ item.subtitle }}</div>
                </div>
              </div>
            </template>
            <div class="no-data" v-else>
              <no-data></no-data>
            </div>
          </div>
          <div class="pagination" v-if="newsList.length > 0">
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :hide-on-single-page="false"
              :current-page="pageNo"
              @current-change="curChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {pageContent} from "../../api/gxHome/api.home";
import noData from "../../components/common/Nodata.vue";
export default {
  data() {
    return {
      pageSize: 5,
      pageNo: 1,
      total: 10,
      tabList: [],
      activeTab: "",
      newsList: [],
      loading: false,
    };
  },
  components: { noData },
  computed: {
    globalData() {
      return this.$store.state.globalData;
    }
  },
  mounted() {
    this.getNav();
  },
  methods: {
    getNav(){
      if (this.globalData) {
        this.tabList = this.globalData;
        let tabList = this.globalData.imageColumnList.concat(this.globalData.columnList);
        let tabName = this.$route.query.tabName;
        let active = tabList.filter((el) => el.columnName === tabName);
        if (tabName && active.length > 0) {
          this.activeTab = active[0];
        } else {
          this.activeTab = tabList.imageColumnList[0];
        }
        this.pageContent();
      }
    },
    tabChange(item) {
      this.activeTab = item;
      this.pageNo = 1;
      this.pageContent();
    },
    curChange(n) {
      this.pageNo = n;
      this.pageContent();
    },
    toHome() {
      this.$router.push("/yt/home");
    },
    toDetail(v) {
      if (v.url&&v.url!=="") {
        window.open(v.url, "_blank");
      } else {
        this.$router.push({
          path: "/yt/detail",
          query: {
            contentId: v.id,
            tabName: this.activeTab.columnName,
            num:this.activeTab.typeCode=="IMAGE_TEXT"?2:3
          },
        });
      }
    },
    pageContent() {
      pageContent({
        columnId: this.activeTab.columnId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.result) {
          res.result.list.forEach(item=>{
            let arr=item.publishDate.split('-');
             item.time=[arr[0],arr[1]+'.'+arr[2]]
          })
          this.newsList = res.result.list;
          this.total = res.result.totalNum;
        }
      });
    },
  },
  watch:{
    $route(news,olds){
       this.getNav();
    },
    globalData() {
      this.getNav();
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  background-color: #faf2e8;
  padding-bottom: 50px;
  margin-top: 70px;
  .list-wrap {
    width: 1200px;
    margin: 0 auto;
    .breadcrumb {
      .breadcrumb-now {
        line-height: 52px;
        display: inline-block;
        color: #6d7177;
        margin-right: 21px;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          right: -10px;
          width: 1px;
          height: 14px;
          background: #c9cfda;
          top: 19px;
        }
      }
      .breadcrumb-item {
        display: inline-block;
        color: #7d3b00;
        cursor: pointer;
        padding-right: 5px;
      }
      .breadcrumb-icon {
        display: inline-block;
        color: #7d3b00;
        padding-right: 5px;
      }
    }
    .list-content {
      display: flex;
      .list-l {
        width: 320px;
        margin-right: 18px;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 10px 0px;
        height: 100%;
        .tit{
           font-size: 18px;
           font-weight: bold;
           text-align: center;
           padding:20px 0px;
        }
        .list-l-item {
          line-height:40px;
          font-size: 16px;
          color: #27231f;
          text-align: center;
          cursor: pointer;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .active {
          color: #7d3b00;
          position: relative;
          font-weight: bold;
          &:after {
            content: "";
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 13px solid #7d3b00;
            border-bottom: 10px solid transparent;
            position: absolute;
            right: 1px;
            top: 10px;
          }
        }
      }
      .list-r {
        flex: 1;
        background-color: #ffffff;
        padding: 26px 30px;
        border-radius: 6px;
        min-height: calc(100vh - 359px);
        .list-r-title {
          font-size: 22px;
          font-weight: bold;
          color: #20252c;
        }
        .list-r-list {
          .no-data {
            padding: 70px 0px;
          }
          .list-r-item {
            display: flex;
            padding: 24px 0px;
            border-bottom: 1px solid #ebeef2;
            cursor: pointer;
            .img {
              width: 138px;
              height: 138px;
              margin-right: 24px;
              border-radius: 4px;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 30px;
              background:#e3e3e3;
              span{
                font-size:16px;
                display: block;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
            .info {
              flex: 1;
              .title {
                font-size: 20px;
                font-weight: bold;
                color: #27231f;
                line-height: 28px;
                margin-bottom: 11px;
                max-width: 640px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                word-wrap: break-word;
              }
              .des {
                font-size: 14px;
                color: #595552;
                line-height: 22px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                -webkit-box-orient: vertical;
                max-width: 640px;
                word-wrap:break-word;
              }
            }
          }
        }
      }
      .pagination {
        padding-top: 30px;
        text-align: center;
        /deep/.el-pagination {
          .el-pager li:not(.disabled).active {
            background-color: #7d3b00;
            &:hover {
              color: #ffffff;
            }
          }
          .el-pager li:not(.disabled):hover {
            color: #7d3b00;
          }
        }
      }
    }
  }
}
</style>